import { render } from "./AlarmSettingsEditGroupsCard.vue?vue&type=template&id=7ae53a66"
import script from "./AlarmSettingsEditGroupsCard.vue?vue&type=script&lang=js"
export * from "./AlarmSettingsEditGroupsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__